import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  faTimes,
  faSave,
  faTrash,
  faCheck } from
"@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { gradeData1 } from "../../../constants/data";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import swal from "sweetalert";
import { Modal, ModalBody } from "reactstrap";

const StudentModal = ({ isOpen, setIsOpen, data }) => {
  return (
    <Fragment>
      <Modal isOpen={isOpen} centered={true}>
        <ModalBody>
          <div style={{ textAlign: "center", padding: "8px 4px" }}>
            <p style={{ marginBottom: "16px", color: "#1f2d26" }}>{data.message}</p>
            <div className="create-student-modal-actions">
              <button
                type="button"
                onClick={data.function1}
                className="create-student-btn primary">

                <FontAwesomeIcon icon={faCheck} />
                Ok
              </button>
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="create-student-btn danger">

                <FontAwesomeIcon icon={faTimes} />
                Cancel
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>);

};

const getActivityLabel = (item) => item?.name || item?.activities_name || "";
const getAthleticLabel = (item) => item?.name || item?.athletics_name || "";
const getCatalogId = (item) => item?.config_id || item?.id;

const CreateStudent = ({
  setOpenCreateMessage,
  modify,
  getStudentwithId,
  setOpenCreateStudent
}) => {
  const counselorRef = useRef();
  const timeoutRef = useRef();
  const activitiesRef = useRef();
  const athleticsRef = useRef();
  const timeout = useRef();
  const [grade, setGrade] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [showCounselorContainer, setShowCounselorContainer] = useState(false);
  const [showActivitiesContainer, setShowAtivitiesContainer] = useState(false);
  const [activitiesList, setActivitiesList] = useState();
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [showAthleticsContainer, setShowAthleticsContainer] = useState(false);
  const [athleticsList, setAthleticsList] = useState();
  const [selectedAthletics, setSelectedAthletics] = useState([]);
  const [counselorList, setCounselorList] = useState([]);
  const [counselorName, setCounselorName] = useState("");
  const [selectedCounselor, setSelectedCounselor] = useState([]);
  const [email, setEmail] = useState();
  const [parentEmail, setParentEmail] = useState();
  const [recoveryEmail, setRecoveryEmail] = useState();
  const [mobile, setMobile] = useState();
  const [parentMobile, setParentMobile] = useState();
  const [parentName, setParentName] = useState();
  const [activities, setActivities] = useState();
  const [athletics, setAthletics] = useState();
  const [firstInFamily, setFirstInFamily] = useState(false);
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [showPasswordError, setShowPasswordError] = useState("");
  const [openMergeModal, setOpenMergeModal] = useState(false);
  const [searchMergeStudent, setSearchMergeStudent] = useState();
  const [mergeStudentId, setMergeStudentId] = useState();
  const [mergeStudentList, setMergeStudentList] = useState();

  const modifyData = () => {
    setSearchMergeStudent("");
    setFirstName(modify?.student?.first_name);
    setLastName(modify?.student?.last_name);
    setGrade(modify?.student?.current_grade);
    setEmail(modify?.student?.email);
    setMobile(modify?.student?.mobile);
    setParentEmail(modify?.student?.parent_email);
    setParentName(modify?.student?.parent_name);
    setParentMobile(modify?.student?.parent_mobile);
    setRecoveryEmail(modify?.student?.recovery_email);
    if (modify?.counselor) setSelectedCounselor([modify?.counselor]);else
    setSelectedCounselor([]);
    setFirstInFamily(modify?.student?.student_first_gen);
    if (modify?.selectedactivities_obj) {
      setSelectedActivities(
        modify.selectedactivities_obj.map((item) => ({
          ...item,
          name: getActivityLabel(item),
        }))
      );
    } else setSelectedActivities([]);
    if (modify?.selectedathletics) {
      setSelectedAthletics(
        modify.selectedathletics.map((item) => ({
          ...item,
          name: getAthleticLabel(item),
        }))
      );
    } else setSelectedAthletics([]);
  };

  useEffect(() => {
    if (modify) {
      modifyData();
      // setNull();
    }
  }, [modify]);

  const getObject = () => {
    // let activitiesId = selectedActivities?.map((item) => item.id);
    // let athleticsId = selectedAthletics?.map((item) => item.id);
    let obj = {
      student_opt_out: true,
      selectedactivities_obj: selectedActivities,
      // selectedactivities: activitiesId,
      selectedathletics_obj: selectedAthletics,
      // selectedathletics: athleticsId,
      counselor: selectedCounselor?.map((item) => item.id) || [],
      current_grade: grade,
      first_name: firstName,
      last_name: lastName,
      email: email,
      parent_email: parentEmail,
      recovery_email: recoveryEmail,
      mobile: mobile,
      parent_mobile: parentMobile,
      parent_name: parentName,
      student_first_gen: firstInFamily,
      user_id: modify?.student?.id,
      type: "student"
    };
    return obj;
  };

  const setNull = () => {
    setSelectedAthletics([]);
    setSelectedActivities([]);
    setSelectedCounselor([]);
    setGrade("");
    setFirstInFamily(false);
    setCounselorName("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setRecoveryEmail("");
    setParentEmail("");
    setMobile("");
    setParentMobile("");
    setPassword("");
    setConfirmPassword("");
    setParentName("");
    setOpenCreateMessage(false);
  };

  const saveButtonHandler = () => {
    let obj = getObject();
    obj.password = password;
    obj.password_confirm = confirmPassword;
    obj.school = user?.school_id;
    GetStudentService.saveStudent(obj)
    .then((data) => {
      setNull();
      getStudentwithId("all");
      setOpenCreateStudent(false);
      swal({
        title: "Created",
        text: data?.data?.message || "Student created successfully!",
        icon: "success",
        buttons: {
          confirm: "OK"
        },
        closeOnClickOutside: false
      });
    })
    .catch((error) => {
      swal({
        title: "Unable to create",
        text:
        error?.response?.data?.message ||
        "Something went wrong while creating the student.",
        icon: "warning",
        dangerMode: true,
        buttons: {
          confirm: "OK"
        },
        closeOnClickOutside: false
      });
    });
  };

  const updateButtonHandler = () => {
    let obj = getObject();
    if (password) obj.password = password;
    GetStudentService.updateStudent(obj)
    .then((data) => {
      setNull();
      getStudentwithId("all");
      setOpenCreateStudent(false);
      swal({
        title: "Updated",
        text: data?.data?.message || "Student updated successfully!",
        icon: "success",
        buttons: {
          confirm: "OK"
        },
        closeOnClickOutside: false
      });
    })
    .catch((error) => {
      swal({
        title: "Unable to update",
        text:
        error?.response?.data?.message ||
        "Something went wrong while updating the student.",
        icon: "warning",
        dangerMode: true,
        buttons: {
          confirm: "OK"
        },
        closeOnClickOutside: false
      });
    });
  };

  const getCounselorName = (value) => {
    GetStudentService.getCounselorName(value, "counselor", user?.school_id)
    .then((data) => {
      setCounselorList(data?.data?.result);
    })
    .catch(() => {});
  };

  const getStudentfromSearchHandler = (q) => {
    let obj = {
      q: q,
      role: "student",
      school: user?.school_id
      // student_id: "with_id",
    };
    GetStudentService.searchStudent(obj)
    .then((data) => {
      setMergeStudentList(data.data.result);
    })
    .catch(() => {});
  };

  const searchHandler = (e) => {
    let q = e.target.value;
    setSearchMergeStudent(q);
    if (q === "") {
      setMergeStudentList();
    } else {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        getStudentfromSearchHandler(q);
      }, 500);
    }
  };

  const mergeStudent = () => {
    let obj = {
      student_with_id: mergeStudentId,
      student_without_id: modify?.student?.id
    };
    GetStudentService.mergeStudent(obj)
    .then((data) => {
      swal({
        text: data?.data?.message,
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: true
        },
        closeOnClickOutside: true
      });
      setOpenMergeModal(false);
    })
    .catch((_error) => {
      setOpenMergeModal(false);
    });
  };

  const deleteStudent = async () => {
    const confirmed = await swal({
      title: "Delete student?",
      text: "Are you sure you want to delete this student?",
      icon: "warning",
      buttons: {
        cancel: "Cancel",
        confirm: "Delete"
      },
      dangerMode: true,
      closeOnClickOutside: false
    });

    if (!confirmed) return;

    GetStudentService.deleteStudent(modify?.student?.id)
    .then((data) => {
      setNull();
      getStudentwithId("all");
      setOpenCreateStudent(false);
      swal({
        title: "Deleted",
        text: data?.data?.message || "Student deleted successfully!",
        icon: "success",
        buttons: {
          confirm: "OK"
        },
        closeOnClickOutside: false
      });
    })
    .catch((error) => {
      swal({
        title: "Unable to delete",
        text:
        error?.response?.data?.message ||
        "Something went wrong while deleting the student.",
        icon: "warning",
        dangerMode: true,
        buttons: {
          confirm: "OK"
        },
        closeOnClickOutside: false
      });
    });
  };

  const counselorHandler = () => {
    clearTimeout(timeoutRef.current);
    if (!counselorName) {
      setShowCounselorContainer(false);
      setCounselorList([]);
    }
    setCounselorName(counselorRef.current.value);
    timeoutRef.current = setTimeout(() => {
      getCounselorName(counselorRef.current.value);
    }, 1000);
    setShowCounselorContainer(true);
  };

  const removeCounselorName = (value) => {
    let filteredValue = selectedCounselor?.filter((item) => item !== value);
    setSelectedCounselor(filteredValue);
  };

  const handleCounselorSelect = (item) => {
    setCounselorName("");
    setSelectedCounselor([...selectedCounselor, item]);
    setCounselorList([]);
    setShowCounselorContainer(false);
  };

  const passwordValidation = (_value) => {
    if (password.length < 8) {
      setShowPasswordError("Password must be greater than 8 characters");
    } else if (password.length >= 8) {
      setShowPasswordError(false);
    }
  };

  const confirmPasswordValidation = (value) => {
    if (value !== password)
    setShowPasswordError("Password and Confirm Password should be same.");else
    setShowPasswordError(false);
  };

  const handleActivitiesChange = () => {
    clearTimeout(timeoutRef.current);
    setActivities(activitiesRef.current.value);
    if (!activitiesRef.current.value) {
      setShowAtivitiesContainer(false);
      setActivitiesList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getActivities(activitiesRef.current.value);
      }, 1000);
    }
    setShowAtivitiesContainer(true);
  };

  const handleAthleticsChange = () => {
    clearTimeout(timeoutRef.current);
    setAthletics(athleticsRef.current.value);
    if (!athleticsRef.current.value) {
      setShowAthleticsContainer(false);
      setAthleticsList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getAthletics(athleticsRef.current.value);
      }, 1000);
    }
    setShowAthleticsContainer(true);
  };

  const getActivities = (value) => {
    let selected = "";
    selectedActivities.forEach((item) => selected += "act=" + getCatalogId(item) + "&");
    GetStudentService.getActivitiesList(value, selected)
    .then((data) => {
      let newObj = data?.data?.objects;
      newObj = newObj.filter(
        (i) => !selectedActivities.some((item) => getCatalogId(item) === i.id)
      );
      setActivitiesList(newObj);
    })
    .catch(() => {});
  };

  const getAthletics = (value) => {
    let selected = "";
    selectedAthletics.forEach((item) => selected += "ath=" + getCatalogId(item) + "&");
    GetStudentService.getAthleticsList(value, selected)
    .then((data) => {
      let newObj = data?.data?.objects;
      newObj = newObj.filter(
        (i) => !selectedAthletics.some((item) => getCatalogId(item) === i.id)
      );
      setAthleticsList(newObj);
    })
    .catch(() => {});
  };

  const handleSelectedActivities = (item) => {
    setActivitiesList([]);
    setShowAtivitiesContainer(false);
    activitiesRef.current.value = null;
    setActivities();
    setSelectedActivities([...selectedActivities, item]);
  };

  const handleSelectedAthletics = (item) => {
    setAthleticsList([]);
    setShowAthleticsContainer(false);
    athleticsRef.current.value = null;
    setAthletics();
    setSelectedAthletics([...selectedAthletics, item]);
  };

  const removeSelectedActivities = (value) => {
    let filteredValue = selectedActivities?.filter((item) => item !== value);
    setSelectedActivities(filteredValue);
  };

  const removeSelectedAthletics = (value) => {
    let filteredValue = selectedAthletics?.filter((item) => item !== value);
    setSelectedAthletics(filteredValue);
  };

  const canSaveNew =
  grade &&
  email &&
  firstName &&
  lastName &&
  password &&
  confirmPassword &&
  !showPasswordError;

  return (
    <Fragment>
      <div className="create-student-container">
        <div className="create-student-header">
          <h2 className="create-student-title">
            {modify ? "Modify Student" : "New Student"}
          </h2>
          <FontAwesomeIcon
            icon={faTimes}
            className="create-student-close"
            onClick={() => {
              setNull();
              setOpenCreateMessage(false);
            }} />

        </div>

        <div className="create-student-body">
          <div className="create-student-section">
            <p className="create-student-section-title">Assignment</p>
            <div className="create-student-field">
              <label className="create-student-label">Counselor</label>
              <input
                type="text"
                className="create-student-input"
                placeholder="Type the counselor name"
                ref={counselorRef}
                onChange={counselorHandler}
                value={counselorName || ""} />

              {showCounselorContainer && counselorList?.length > 0 &&
              <ul className="create-student-dropdown maintain-group-student-dropdown-menu">
                  {counselorList.map((item, index) =>
                <li
                  onClick={() => handleCounselorSelect(item)}
                  key={item?.id || index}
                  className="flex maintain-group-student-list cursor">

                      <span>{item?.name}</span>
                    </li>
                )}
                </ul>}

              {selectedCounselor?.length > 0 &&
              <div className="create-student-chips">
                  {selectedCounselor.map((item) =>
                <div key={item?.id || item?.name} className="create-student-chip">
                      {item.name}
                      <FontAwesomeIcon
                    icon={faTimes}
                    onClick={() => removeCounselorName(item)} />

                    </div>
                )}
                </div>}

            </div>

            <div className="create-student-field">
              <label className="create-student-label">
                Grade <span className="create-student-required">*</span>
              </label>
              <select
                value={grade || ""}
                onChange={(e) => setGrade(e.target.value)}
                className="create-student-select">

                <option disabled value="">
                  Select Current Grade
                </option>
                {gradeData1.map((item, index) =>
                <option
                  key={item?.value || index}
                  style={{ textTransform: "capitalize" }}
                  value={item?.value}>

                    {item?.name}
                  </option>
                )}
              </select>
            </div>
          </div>

          <div className="create-student-section">
            <p className="create-student-section-title">Personal information</p>
            <div className="create-student-field">
              <label className="create-student-label">
                First Name <span className="create-student-required">*</span>
              </label>
              <input
                type="text"
                className="create-student-input"
                placeholder="First Name"
                value={firstName || ""}
                onChange={(e) => setFirstName(e.target.value)} />

            </div>
            <div className="create-student-field">
              <label className="create-student-label">
                Last Name <span className="create-student-required">*</span>
              </label>
              <input
                type="text"
                className="create-student-input"
                placeholder="Last Name"
                value={lastName || ""}
                onChange={(e) => setLastName(e.target.value)} />

            </div>
          </div>

          <div className="create-student-section">
            <p className="create-student-section-title">Contact</p>
            <div className="create-student-field">
              <label className="create-student-label">Email</label>
              <input
                type="email"
                className="create-student-input"
                placeholder="Email"
                value={email || ""}
                onChange={(e) => setEmail(e.target.value.toLowerCase())} />

            </div>
            <div className="create-student-field">
              <label className="create-student-label">Parent Email</label>
              <input
                type="email"
                className="create-student-input"
                placeholder="Parent Email"
                value={parentEmail || ""}
                onChange={(e) => setParentEmail(e.target.value.toLowerCase())} />

              <p className="create-student-hint">
                Email address for daily/weekly activity log to be sent
              </p>
            </div>
            <div className="create-student-field">
              <label className="create-student-label">Secondary Email</label>
              <input
                type="email"
                className="create-student-input"
                placeholder="Secondary Email"
                value={recoveryEmail || ""}
                onChange={(e) =>
                setRecoveryEmail(e.target.value.toLowerCase())} />


              <p className="create-student-hint">
                Used in case account needs to be recovered
              </p>
            </div>
            <div className="create-student-field">
              <label className="create-student-label">Mobile</label>
              <input
                type="text"
                className="create-student-input"
                placeholder="+19999999999"
                onChange={(e) => setMobile(e.target.value)}
                value={mobile || ""} />

              <p className="create-student-hint">Hint: +13238511115</p>
            </div>
            <div className="create-student-field">
              <label className="create-student-label">Parent Mobile</label>
              <input
                type="text"
                className="create-student-input"
                placeholder="+19999999999"
                value={parentMobile || ""}
                onChange={(e) => setParentMobile(e.target.value)} />

              <p className="create-student-hint">Hint: +13238511115</p>
            </div>
            <div className="create-student-field">
              <label className="create-student-label">Parent Name</label>
              <input
                type="text"
                className="create-student-input"
                placeholder="Parent Name"
                value={parentName || ""}
                onChange={(e) => setParentName(e.target.value)} />

            </div>
            <div className="create-student-field">
              <label className="create-student-label">Activities</label>
              <input
                type="text"
                className="create-student-input"
                placeholder="Type an activity name to add"
                onChange={handleActivitiesChange}
                ref={activitiesRef}
                value={activities || ""}
                autoComplete="off" />

              {showActivitiesContainer && activitiesList?.length > 0 &&
              <ul className="create-student-dropdown maintain-group-student-dropdown-menu">
                  {activitiesList.map((item, index) =>
                <li
                  onClick={() => handleSelectedActivities(item)}
                  key={item?.id || index}
                  className="flex maintain-group-student-list cursor">

                      <span>{item.name}</span>
                    </li>
                )}
                </ul>}

              {selectedActivities?.length > 0 &&
              <div className="create-student-chips">
                  {selectedActivities.map((item, index) =>
                <div
                  key={getCatalogId(item) || getActivityLabel(item) || index}
                  className="create-student-chip">

                      {getActivityLabel(item)}
                      <FontAwesomeIcon
                    icon={faTimes}
                    onClick={() => removeSelectedActivities(item)} />

                    </div>
                )}
                </div>}

            </div>
            <div className="create-student-field">
              <label className="create-student-label">Athletics</label>
              <input
                ref={athleticsRef}
                type="text"
                className="create-student-input"
                placeholder="Type an athletics name to add"
                value={athletics || ""}
                onChange={handleAthleticsChange}
                autoComplete="off" />

              {showAthleticsContainer && athleticsList?.length > 0 &&
              <ul className="create-student-dropdown maintain-group-student-dropdown-menu">
                  {athleticsList.map((item, index) =>
                <li
                  onClick={() => handleSelectedAthletics(item)}
                  key={item?.id || index}
                  className="flex maintain-group-student-list cursor">

                      <span>{item.name}</span>
                    </li>
                )}
                </ul>}

              {selectedAthletics?.length > 0 &&
              <div className="create-student-chips">
                  {selectedAthletics.map((item, index) =>
                <div
                  key={getCatalogId(item) || getAthleticLabel(item) || index}
                  className="create-student-chip">

                      {getAthleticLabel(item)}
                      <FontAwesomeIcon
                    icon={faTimes}
                    onClick={() => removeSelectedAthletics(item)} />

                    </div>
                )}
                </div>}

            </div>
          </div>

          <label className="create-student-check">
            <input
              type="checkbox"
              value={firstInFamily}
              onChange={() => setFirstInFamily(!firstInFamily)}
              checked={!!firstInFamily} />

            <span>
              Please check the box if you are the first in your family who wants
              to attend College.
            </span>
          </label>

          <div className="create-student-section">
            <p className="create-student-section-title">User information</p>
            <div className="create-student-field">
              <label className="create-student-label">
                Password <span className="create-student-required">*</span>
              </label>
              <input
                type="password"
                className="create-student-input"
                placeholder="Password"
                value={password || ""}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={() => passwordValidation(password)} />

            </div>
            <div className="create-student-field">
              <label className="create-student-label">
                Confirm Password{" "}
                <span className="create-student-required">*</span>
              </label>
              <input
                type="password"
                className="create-student-input"
                placeholder="Confirm Password"
                value={confirmPassword || ""}
                onChange={(e) => setConfirmPassword(e.target.value)}
                onBlur={() => confirmPasswordValidation(confirmPassword)} />

            </div>

            {modify && !modify?.student?.student_id &&
            <div className="create-student-field">
                <label className="create-student-label">
                  Merge with Student
                </label>
                <div className="create-student-merge-row">
                  <input
                  type="text"
                  className="create-student-input"
                  placeholder="Name of the student to Merge With"
                  onChange={searchHandler}
                  value={searchMergeStudent || ""} />

                  <button
                  type="button"
                  className="create-student-btn secondary"
                  disabled={!searchMergeStudent}
                  onClick={() => setOpenMergeModal(true)}>

                    <FontAwesomeIcon icon={faSave} />
                    Merge
                  </button>
                </div>
                {mergeStudentList?.length > 0 &&
              <ul className="create-student-dropdown maintain-group-student-dropdown-menu">
                    {mergeStudentList.map((item, index) =>
                <li
                  onClick={() => {
                    setSearchMergeStudent(item.name);
                    setMergeStudentId(item.id);
                    setMergeStudentList();
                  }}
                  key={item?.id || index}
                  className="flex maintain-group-student-list cursor">

                        <span>
                          {item.name}&nbsp;{item.email}
                        </span>
                      </li>
                )}
                  </ul>}

                <p className="create-student-note">
                  This student account does not have a student ID associated
                  with it. Please merge it with a student that does have an ID.
                </p>
              </div>}

          </div>

          {showPasswordError &&
          <p className="create-student-error">{showPasswordError}</p>}


          <div className="create-student-actions">
            {modify &&
            <button
              type="button"
              className="create-student-btn danger"
              onClick={deleteStudent}>

                <FontAwesomeIcon icon={faTrash} />
                Delete
              </button>}

            {modify &&
            <button
              type="button"
              onClick={updateButtonHandler}
              className="create-student-btn primary">

                <FontAwesomeIcon icon={faSave} />
                Update
              </button>}

            {!modify &&
            <button
              type="button"
              onClick={saveButtonHandler}
              disabled={!canSaveNew}
              className="create-student-btn primary">

                <FontAwesomeIcon icon={faSave} />
                Create
              </button>}

          </div>
        </div>
      </div>

      {openMergeModal &&
      <StudentModal
        setIsOpen={setOpenMergeModal}
        isOpen={openMergeModal}
        data={{
          function1: mergeStudent,
          message: "Are you sure you want to merge this student?"
        }} />}


    </Fragment>);

};

export default CreateStudent;